import React from 'react';

// Assets
// import Logo from './../../assets/logo.png'

// Libraries
import { Flex, Spinner } from '@chakra-ui/core'

export const Loader = () => {
  return (
    <Flex justifyContent="center" alignItems="center" h="80vh" textAlign="center">
      {/* <Image src={Logo} alt="t40" w="50px" /> */}
      <Spinner thickness="4px" color="brand.primary" size="lg" />
    </Flex>
  )
}
